/*******************************************************
 * Variant Options
 * Top-level sets of variant options.
 * - These show in the "Variants" pane in Figma
 * - Will be props in react components
 * - Will be class name modifiers in CSS output
 ******************************************************/
/**
 * Variant Option - SIZE
 */
var SizeVariant;
(function (SizeVariant) {
    SizeVariant["medium"] = "medium";
    SizeVariant["small"] = "small";
})(SizeVariant || (SizeVariant = {}));
/**
 * Variant Option - CIRCLE
 */
var CircleVariant;
(function (CircleVariant) {
    CircleVariant["yes"] = "yes";
    CircleVariant["no"] = "no";
    CircleVariant["solid"] = "solid";
})(CircleVariant || (CircleVariant = {}));
/**
 * Variant Option - COLOR
 */
var ColorVariant;
(function (ColorVariant) {
    ColorVariant["none"] = "none";
    ColorVariant["bermudaViola"] = "bermudaViola";
    ColorVariant["violaPolo"] = "violaPolo";
    ColorVariant["buttermilkBermuda"] = "buttermilkBermuda";
    ColorVariant["poloMint"] = "poloMint";
    // Used only in Figma originals
    ColorVariant["default"] = "default";
})(ColorVariant || (ColorVariant = {}));

export { CircleVariant, ColorVariant, SizeVariant };
//# sourceMappingURL=variant-enums.esm.js.map
